import React from 'react';

const Oferta = () => {
  return (
    <section className="privacy-section legal-page-section">
      <button
        type="button"
        className="legal-back-link legal-back-link-top"
        onClick={() => {
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = '/';
          }
        }}
      >
        ← Вернуться назад
      </button>


      <div className="card legal-page-card">
<h2 className="section-title">Публичная оферта на заключение агентского договора</h2>

        <article>
          <p><strong>г. Новосибирск</strong></p>
          <p><strong>05.02.2025 года</strong></p>

          <p>
            Индивидуальный предприниматель Чеботарева Ирина Анатольевна, именуемая в дальнейшем
            «Агент», публикует настоящую публичную оферту (далее — «Оферта») о заключении
            агентского договора с любым дееспособным физическим лицом, выразившим готовность
            воспользоваться услугами Агента (далее — «Принципал»), на условиях, указанных ниже.
          </p>

          <p>
            Настоящая Оферта составлена в соответствии с положениями статьи 437 и статьи 1005
            Гражданского кодекса Российской Федерации.
          </p>

          <p>
            Принятие (акцепт) оферты осуществляется путем совершения действий, предусмотренных
            разделом 2 Договора, что считается полным и безоговорочным согласием с условиями
            настоящего Договора.
          </p>
        </article>

        <article>
          <h3>1. Предмет договора</h3>
          <p>
            1.1. Агент обязуется по поручению и за счет Принципала осуществить организацию закупки
            товаров для личного пользования, выбранных Принципалом в зарубежных интернет-магазинах
            (например, Amazon, eBay и др.), включая:
          </p>
          <ul>
            <li>оформление заказа;</li>
            <li>оплату товара от имени и за счет Принципала;</li>
            <li>организацию доставки товара до территории Российской Федерации.</li>
          </ul>
          <p>
            1.2. Агент не является продавцом указанных товаров, не осуществляет их поставку,
            производство или контроль качества.
          </p>
          <p>
            1.3. Агент действует от своего имени, но за счет Принципала, в соответствии со
            статьей 1005 ГК РФ.
          </p>
        </article>

        <article>
          <h3>2. Порядок акцепта оферты и заключения договора</h3>
          <p>2.1. Акцептом настоящей Оферты считается:</p>
          <ul>
            <li>оформление и оплата Принципалом заявки на сайте / в мессенджере / по электронной почте;</li>
            <li>внесение предоплаты за заказ по выставленному Агентом счету.</li>
          </ul>
          <p>
            2.2. С момента акцепта настоящая Оферта считается заключённым агентским договором в
            соответствии со статьей 438 ГК РФ.
          </p>
        </article>

        <article>
          <h3>3. Права и обязанности сторон</h3>
          <p>3.1. Агент обязуется:</p>
          <ul>
            <li>осуществить заказ товара в соответствии с заявкой Принципала;</li>
            <li>предоставить Принципалу информацию о стоимости заказа и сроках доставки;</li>
            <li>
              организовать доставку товара до территории РФ через третьих лиц — транспортные компании
              и/или курьерские службы.
            </li>
          </ul>

          <p>3.2. Агент имеет право:</p>
          <ul>
            <li>отказать в исполнении заявки без объяснения причин, вернув средства, если они были перечислены;</li>
            <li>привлекать третьих лиц для исполнения своих обязательств;</li>
            <li>удерживать агентское вознаграждение из средств Принципала.</li>
          </ul>

          <p>3.3. Принципал обязуется:</p>
          <ul>
            <li>предоставить точную информацию о желаемом товаре и его характеристиках;</li>
            <li>своевременно оплатить стоимость товара, агентское вознаграждение и услуги по доставке;</li>
            <li>принять товар после доставки.</li>
          </ul>

          <p>3.4. Принципал подтверждает, что:</p>
          <ul>
            <li>
              приобретаемые товары предназначены исключительно для личного пользования
              (в соответствии со статьей 238 Таможенного кодекса ЕАЭС и статьей 12 Закона РФ
              «О защите прав потребителей»);
            </li>
            <li>
              он самостоятельно несёт все риски, связанные с качеством и функциональностью заказанных товаров;
            </li>
            <li>
              в связи с акцептом настоящей оферты и получением полной информации о заказе, Агент
              освобождается от обязанности представления отчетов, предусмотренных ст. 1008 ГК РФ.
            </li>
          </ul>
        </article>

        <article>
          <h3>4. Стоимость услуг и порядок расчетов</h3>
          <p>4.1. Общая стоимость включает:</p>
          <ul>
            <li>стоимость самого товара;</li>
            <li>агентское вознаграждение — фиксированное или процент от стоимости товара;</li>
            <li>стоимость международной и внутренней доставки.</li>
          </ul>

          <p>4.2. Оплата осуществляется в два этапа:</p>
          <ul>
            <li>
              предоплата за заказ и услуги Агента производится до выкупа заказа или в течение
              24 часов с момента направления счета;
            </li>
            <li>
              оплата доставки после поступления товара на склад в РФ — до выдачи Принципалу —
              оплачивается в течение 24 часов с момента отправки счета.
            </li>
          </ul>
        </article>

        <article>
          <h3>5. Порядок взаимодействия сторон и отчетность</h3>
          <p>
            5.1. Каждая оплата, произведенная Принципалом (Покупателем) на основании настоящей
            Оферты, считается самостоятельным поручением Агента на совершение разовой сделки по
            приобретению и поставке определенного товара.
          </p>
          <p>
            5.2. После выполнения такого поручения Агент считается полностью исполнившим свои
            обязательства, и агентские отношения в отношении соответствующей суммы прекращаются.
          </p>
          <p>
            5.3. Принципал подтверждает, что направленные ему электронные чеки, счета, квитанции
            об оплате, подтверждение отправки заказа и иные документы, содержащие сведения о товаре
            и размере агентского вознаграждения, являются достаточным подтверждением исполнения
            поручения и заменяют собой отчет агента, предусмотренный ст. 1008 Гражданского кодекса РФ.
          </p>
          <p>
            5.4. Принципал освобождает Агента от обязанности предоставления отдельного письменного
            отчета, если иное не будет прямо запрошено в письменной форме в течение 5 (пяти)
            рабочих дней с момента получения электронных документов, указанных в п. 5.3 настоящей Оферты.
          </p>
        </article>

        <article>
          <h3>6. Ответственность сторон</h3>
          <p>6.1. Агент не несет ответственности:</p>
          <ul>
            <li>за несоответствие товара ожиданиям Принципала;</li>
            <li>
              за заводской брак, повреждение товара в пути или его утерю по вине третьих лиц —
              продавца, перевозчика и т.д.;
            </li>
            <li>за невозможность возврата или обмена товара.</li>
          </ul>
          <p>
            6.2. Агент гарантирует надлежащее оформление заказа, но не участвует в процессе возврата
            товара продавцу.
          </p>
          <p>
            6.3. Агент действует добросовестно, но не гарантирует соблюдение сроков доставки, так как
            это зависит от третьих лиц.
          </p>
        </article>

        <article>
          <h3>7. Возврат и отказ от договора</h3>
          <p>
            7.1. После оформления заказа отказ от исполнения договора невозможен, так как Агент уже
            начал его исполнение (ст. 782 ГК РФ).
          </p>
          <p>
            7.2. Возврат денежных средств возможен только в случае невозможности исполнения заказа
            по вине Агента.
          </p>
        </article>

        <article>
          <h3>8. Форс-мажор</h3>
          <p>
            8.1. Стороны освобождаются от ответственности за частичное или полное неисполнение
            обязательств по договору при наступлении обстоятельств непреодолимой силы
            (форс-мажора) в соответствии со ст. 401 ГК РФ.
          </p>
        </article>

        <article>
          <h3>9. Заключительные положения</h3>
          <p>
            9.1. Агент имеет право в любое время изменить условия настоящей Оферты. Актуальная
            редакция публикуется на сайте / по месту оформления заявки.
          </p>
          <p>
            9.2. На отношения сторон распространяется законодательство Российской Федерации.
          </p>
          <p>
            9.3. Все споры разрешаются в порядке, установленном законодательством РФ.
            Претензионный порядок для Сторон обязателен.
          </p>
        </article>

        <article>
          <h3>Реквизиты Агента</h3>
          <ul>
            <li>Индивидуальный предприниматель Чеботарева Ирина Анатольевна</li>
            <li>ИНН: 540860074774</li>
            <li>ОГРНИП: 325547600018650</li>
            <li>Email: <a href="mailto:ichebotareva@yahoo.com">ichebotareva@yahoo.com</a></li>
            <li>Телефон: <a href="tel:+79130117070">+79130117070</a></li>
            <li>Сайт: <a href="https://www.shoptopbrands.ru">www.shoptopbrands.ru</a></li>
          </ul>
        </article>
</div>

      <button
        type="button"
        className="legal-back-link legal-back-link-bottom"
        onClick={() => {
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = '/';
          }
        }}
      >
        ← Вернуться назад
      </button>

    </section>
  );
};

export default Oferta;
